import { render, staticRenderFns } from "./FieldColor.vue?vue&type=template&id=a3459782&scoped=true"
import script from "./FieldColor.vue?vue&type=script&lang=js"
export * from "./FieldColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3459782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3459782')) {
      api.createRecord('a3459782', component.options)
    } else {
      api.reload('a3459782', component.options)
    }
    module.hot.accept("./FieldColor.vue?vue&type=template&id=a3459782&scoped=true", function () {
      api.rerender('a3459782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldColor.vue"
export default component.exports